import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './styles/main.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// Retirer le splash après le premier rendu React complet
requestAnimationFrame(() => requestAnimationFrame(() => {
  const splash = document.getElementById('app-splash');
  if (!splash) return;
  splash.style.transition = 'opacity 0.35s ease';
  splash.style.opacity = '0';
  setTimeout(() => { try { splash.remove(); } catch {} }, 380);

  // Initialiser Sentry et SW après le premier paint (hors chemin critique)
  setTimeout(() => {
    import('./sentry').then(({ initSentry }) => initSentry()).catch(() => {});
    serviceWorkerRegistration.register();
    import('./reportWebVitals').then(({ default: reportWebVitals }) => reportWebVitals()).catch(() => {});
  }, 0);
}));

// Récupération automatique sur corruption IndexedDB Firestore (bug SDK b815)
window.addEventListener('unhandledrejection', (event) => {
  const msg = event.reason?.message || String(event.reason || '');
  if (msg.includes('INTERNAL ASSERTION FAILED') || msg.includes('b815')) {
    event.preventDefault();
    if (window.__firestoreRecovering__) return;
    window.__firestoreRecovering__ = true;
    // Supprimer les bases IndexedDB Firestore corrompues puis recharger
    const deleteDBs = async () => {
      try {
        if (indexedDB.databases) {
          const dbs = await indexedDB.databases();
          await Promise.all(
            dbs
              .filter((d) => d.name && d.name.includes('firestore'))
              .map((d) => new Promise((res) => {
                const req = indexedDB.deleteDatabase(d.name);
                req.onsuccess = res;
                req.onerror = res;
              }))
          );
        }
      } catch (_) {}
      window.location.reload();
    };
    deleteDBs();
  }
});

